import { render, staticRenderFns } from "./AllTeamTable.vue?vue&type=template&id=08bb319c&scoped=true&"
import script from "./AllTeamTable.vue?vue&type=script&lang=js&"
export * from "./AllTeamTable.vue?vue&type=script&lang=js&"
import style0 from "./AllTeamTable.vue?vue&type=style&index=0&id=08bb319c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb319c",
  null
  
)

export default component.exports